/* eslint-disable no-console */
import { useEffect, lazy, Suspense } from 'react';
import amplitude from 'amplitude-js';

import { ApolloProvider } from 'react-apollo';

import { useAppDispatch, useAppSelector } from 'hooks/useAppStore';
import { authenticate } from 'redux/reducersV2/authAction';
import { selectUi } from 'redux/selectors/ui';
import { IUserItem } from 'views/auth/LoginRedesign/AccountSelectionModal';
import InstallButton from 'redesign/TopMenu/ShortcutButton';
import { createApolloClient } from './graphql-client';
import { SocketContext, socket } from './events';

import firebase from './config/firebase';
import CssLoadingSpinner from './utils/CssLoadingSpinner';
import LoginRedesign from './views/auth/LoginRedesign/LoginRedesign';
import { VERSION } from './constants';

const client = createApolloClient();

export const Router = lazy(() => import('./views/Router'));

const App = ({ deferredPrompt }: { deferredPrompt: any }) => {
	console.log('gql env', process.env.REACT_APP_ENVIROMENT);
	// console.log('gql endpoint', process.env.REACT_APP_GRAPHQL_ENDPOINT);
	// console.log('gql nest endpoint', process.env.REACT_APP_NEST_BACKEND_URL);
	console.log('version', VERSION);
	const authState = useAppSelector(selectUi);
	const dispatch = useAppDispatch();
	const onAuthChanged = firebase.auth().onAuthStateChanged;

	useEffect(() => {
		const hasuraKey = localStorage.getItem('key') ?? '';
		const tipoUsuario = localStorage.getItem('tp') ?? '';
		dispatch(authenticate({ hasuraKey, tipoUsuario } as IUserItem));
	}, [dispatch, onAuthChanged]);

	amplitude.getInstance().init(process.env.REACT_APP_AMPLITUDE_KEY || '');

	if (authState === 'loading') {
		return <CssLoadingSpinner />;
	}

	if (authState === 'login') {
		return (
			<Suspense fallback={<CssLoadingSpinner />}>
				<SocketContext.Provider value={socket}>
					<ApolloProvider client={client}>
						<InstallButton deferredPrompt={deferredPrompt} />
						<Router />
					</ApolloProvider>
				</SocketContext.Provider>
			</Suspense>
		);
	}

	if (authState === 'logout') {
		return (
			<Suspense fallback={<CssLoadingSpinner />}>
				<ApolloProvider client={client}>
					<LoginRedesign />
				</ApolloProvider>
			</Suspense>
		);
	}

	return null;
};

export default App;
